import React from 'react';

import { css, cx } from '@tanium/react-emotion-9';
import { TextInput } from '@tanium/react-text-input';

import AdvancedFilterInput, {
  AdvancedFilterInputProps,
  RenderPropArgs,
} from './AdvancedFilterInput';

const TextInputStyle = css({
  width: 200,
});

export interface AdvancedFilterTextInputProps
  extends Pick<AdvancedFilterInputProps, 'label' | 'dataKey'>,
    Omit<React.ComponentPropsWithoutRef<typeof TextInput>, 'css'> {}

/**
 * A simple text input for use in AdvancedFilters component.
 */
const AdvancedFilterTextInput = ({
  label,
  dataKey,
  className,
  ...rest
}: AdvancedFilterTextInputProps) => (
  <AdvancedFilterInput {...{ label, dataKey }}>
    {({ updateFilter, idForInput, filterValue = '' }: RenderPropArgs) => (
      <TextInput
        {...rest}
        className={cx(TextInputStyle, className)}
        value={filterValue}
        id={idForInput}
        onChange={({ target: { value: text } }) => {
          updateFilter({ value: text || undefined });
        }}
      />
    )}
  </AdvancedFilterInput>
);

export default AdvancedFilterTextInput;
